import React, { useEffect, useState } from "react";
import { auth } from "../firebase";
import { applyActionCode, checkActionCode } from "firebase/auth";
import "./EmailChange.css"; // Reuse styling from the email change CSS

const RecoverEmail = ({ actionCode }) => {
  const [previousEmail, setPreviousEmail] = useState(null);
  const [statusMessage, setStatusMessage] = useState("Verifying your email recovery request...");
  const [isRecovered, setIsRecovered] = useState(false);
  const APP_NAME = "Guardian Mobile"; // Replace with your app's name

  useEffect(() => {
    const verifyRecovery = async () => {
      try {
        const info = await checkActionCode(auth, actionCode);
        // If Firebase returns previousEmail, use it. Otherwise, warn that it's missing.
        if (info.data.previousEmail) {
          console.log(info.data);
          setPreviousEmail(info.data.email);
          setStatusMessage(`Your sign-in email for ${APP_NAME} is set to recover to ${info.data.email}.`);
        } else {
          // Fallback message if previousEmail is not available.
          setStatusMessage("Previous email information is not available. Please contact support.");
        }
      } catch (err) {
        setStatusMessage(`Error verifying email recovery: ${err.message}`);
      }
    };
    verifyRecovery();
  }, [actionCode]);

  const handleRecover = async () => {
    try {
      await applyActionCode(auth, actionCode);
      setStatusMessage(`Your email has been recovered to ${previousEmail} successfully! 🎉`);
      setIsRecovered(true);
    } catch (err) {
      setStatusMessage(`Error recovering email: ${err.message}`);
    }
  };

  return (
    <div className="email-change-container">
      <div className="email-change-card">
        <div className="logo-container">
          <img src="/guardianLogo.png" alt="Logo" className="logo" />
        </div>
        <h2 className="email-change-title">Recover Email Address</h2>
        <p className="email-change-instructions">{statusMessage}</p>
        {!isRecovered && previousEmail && (
          <button onClick={handleRecover} className="email-change-button">
            Confirm Email Recovery
          </button>
        )}
        {isRecovered && (
          <p className="status-message">
            Your sign-in email for {APP_NAME} has been successfully recovered to {previousEmail}.
          </p>
        )}
      </div>
    </div>
  );
};

export default RecoverEmail;
